export const channels = [
  {
    key: "game",
    name: "游戏竞技",
    icon: "ri-gamepad-line",
    desc: "MOBA、FPS、主机大作与电竞联赛，第一时间看主播上分与精彩团战。",
  },
  {
    key: "entertainment",
    name: "娱乐综艺",
    icon: "ri-emotion-happy-line",
    desc: "脱口秀、才艺秀、连麦互动，轻松欢乐一整天不停歇。",
  },
  {
    key: "education",
    name: "教育培训",
    icon: "ri-book-open-line",
    desc: "语言、编程、考研与职场技能，名师直播带你高效学习。",
  },
  {
    key: "life",
    name: "生活日常",
    icon: "ri-restaurant-2-line",
    desc: "美食烹饪、手工、旅居与好物分享，感受真实烟火气。",
  },
  {
    key: "sports",
    name: "体育赛事",
    icon: "ri-basketball-line",
    desc: "篮球、足球、格斗与极限运动，专业解说陪你热血看赛。",
  },
  {
    key: "music",
    name: "音乐现场",
    icon: "ri-music-2-line",
    desc: "livehouse、翻唱与乐器演奏，随时随地听一场演唱会。",
  },
];